export const environment = {
  name: 'TW Foods',
  imageName: 'twfoods',
  production: false,
  report: true,
  version: '0.1.0',
  passSteps: false,
  freight: true,
  hideCustomerInsert: false,
  incrementByPackaging: false,
  BASE_API_URL: '/bspdv-backend-homolog/api/',
};
